import { addMonths, isPast } from 'date-fns'
import { findExternalBookings } from 'patient-api-lib'

import { protoToZonedTimeDate } from '@/utils/dateFormatters'

// TODO!: Remake on UseQuery
export const getMyNextVisit = async (jwt: string | undefined, clinicIds: string[] | null) => {
  if (!jwt) {
    throw new Error('JWT is missing')
  }

  const dateFrom = addMonths(new Date(), -36)
  const dateTo = addMonths(new Date(), 12)

  if (!clinicIds) {
    throw new Error('Clinic IDs are missing')
  }

  const response = await findExternalBookings(jwt, [...clinicIds], dateFrom, dateTo, '1', undefined)
  const bookingList = response.getExternalBookingsList().map((booking) => booking.toObject())

  if (bookingList.length === 0) {
    return null
  }

  const futureBookings = bookingList.filter(
    (booking) => booking.startTime && !isPast(protoToZonedTimeDate(booking.startTime))
  )
  const sortedFutureBookings = futureBookings.sort((a, b) => {
    const dateA = protoToZonedTimeDate(a.startTime!).getTime()
    const dateB = protoToZonedTimeDate(b.startTime!).getTime()

    return dateB - dateA
  })

  return sortedFutureBookings.length > 0 ? sortedFutureBookings[sortedFutureBookings.length - 1] : null
}
